module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Pages")]), _vm._v(" "), _c('page-list', {
    ref: "pageList",
    attrs: {
      "data-pages": _vm.pages
    },
    on: {
      "page-data": function($event) {
        _vm.selectPageSEO($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Manage SEO / Header Tags")]), _vm._v(" "), (_vm.selected.page) ? _c('p', [_vm._v("Selected Page: " + _vm._s(this.selected.page))]) : _vm._e(), _vm._v(" "), (_vm.selected.tag) ? _c('p', [_vm._v("Selected Tag: " + _vm._s(this.selected.tag))]) : _vm._e(), _vm._v(" "), (!_vm.currentPageSEO.disable) ? _c('div', [_c('seo-tag-input', {
    model: {
      value: (_vm.currentPageSEO),
      callback: function($$v) {
        _vm.currentPageSEO = $$v
      },
      expression: "currentPageSEO"
    }
  }), _vm._v(" "), (!_vm.editTagSEO) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.savePageSEO()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.editTagSEO) ? _c('button', {
    on: {
      "click": _vm.updateSearchedTag
    }
  }, [_vm._v("Save")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Tags")]), _vm._v(" "), (_vm.currentPageSEO.disable) ? _c('div', [_c('h4', [_vm._v("New Tag")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tag"
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.createTagSeo()
      }
    }
  }, [_vm._v("Create")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('search-dropdown', {
    attrs: {
      "placeholder": "Please Search For Tag",
      "options": _vm.tags
    },
    on: {
      "value": _vm.getDropdownQuery
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efbbb7d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/seo.vue
// module id = 684
// module chunks = 1